export const listingIds = [
    '121.3719555.3734276',
    '611.6061135.3740665',
    '615.8368161.4427147',
    '616.8782921.4854059',
    '616.6847574.4025643'
];
